var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPpcCostPerPatient(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: 173.872,
    viewBox: "0 0 320.105 173.872",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3122",
    "data-name": "Group 3122",
    transform: "translate(-102.895 -3949.636)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_50",
    "data-name": "$50",
    transform: "translate(126.367 4041.77)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -16.846,
    y: 0
  }, "$50")), /*#__PURE__*/React.createElement("text", {
    id: "_100",
    "data-name": "$100",
    transform: "translate(126.367 4000.201)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -22.461,
    y: 0
  }, "$100")), /*#__PURE__*/React.createElement("text", {
    id: "_150",
    "data-name": "$150",
    transform: "translate(125.895 3959.636)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -22.461,
    y: 0
  }, "$150")), /*#__PURE__*/React.createElement("text", {
    id: "_0",
    "data-name": 0,
    transform: "translate(126.367 4083.337)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -5.615,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    id: "May",
    transform: "translate(237.267 4102.537)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9.451,
    y: 0
  }, "May")), /*#__PURE__*/React.createElement("text", {
    id: "Mar",
    transform: "translate(186.854 4101.537)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8.777,
    y: 0
  }, "Mar")), /*#__PURE__*/React.createElement("text", {
    id: "Jan",
    transform: "translate(139.158 4102.537)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8.237,
    y: 0
  }, "Jan")), /*#__PURE__*/React.createElement("text", {
    id: "Month",
    transform: "translate(276.281 4120.508)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -14.363,
    y: 0
  }, "Month")), /*#__PURE__*/React.createElement("text", {
    id: "Sep",
    transform: "translate(338.303 4102.537)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8.42,
    y: 0
  }, "Sep")), /*#__PURE__*/React.createElement("text", {
    id: "Jul",
    transform: "translate(288.009 4102.537)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -6.729,
    y: 0
  }, "Jul")), /*#__PURE__*/React.createElement("text", {
    id: "Nov",
    transform: "translate(387.541 4102.537)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8.801,
    y: 0
  }, "Nov")), /*#__PURE__*/React.createElement("text", {
    id: "Jun",
    transform: "translate(262.677 4101.537)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8.274,
    y: 0
  }, "Jun")), /*#__PURE__*/React.createElement("text", {
    id: "Apr",
    transform: "translate(212.099 4102.537)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -7.759,
    y: 0
  }, "Apr")), /*#__PURE__*/React.createElement("text", {
    id: "Feb",
    transform: "translate(161.612 4102.537)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8.218,
    y: 0
  }, "Feb")), /*#__PURE__*/React.createElement("text", {
    id: "Oct",
    transform: "translate(363.544 4102.537)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -7.688,
    y: 0
  }, "Oct")), /*#__PURE__*/React.createElement("text", {
    id: "Aug",
    transform: "translate(313.065 4101.537)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8.796,
    y: 0
  }, "Aug")), /*#__PURE__*/React.createElement("text", {
    id: "Dec",
    transform: "translate(414 4102.537)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8.545,
    y: 0
  }, "Dec")), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    y1: 134.491,
    transform: "translate(138.678 3956.636)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    y1: 134.491,
    transform: "translate(187.261 3956.636)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    y1: 134.491,
    transform: "translate(237.807 3956.636)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    y1: 134.491,
    transform: "translate(288.353 3956.636)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    "data-name": "Line 6",
    y1: 134.491,
    transform: "translate(338.899 3956.636)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    "data-name": "Line 7",
    y1: 134.491,
    transform: "translate(388.019 3956.636)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    y1: 134.491,
    transform: "translate(161.988 3956.636)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    "data-name": "Line 9",
    y1: 134.491,
    transform: "translate(212.534 3956.636)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10",
    "data-name": "Line 10",
    y1: 134.491,
    transform: "translate(263.08 3956.636)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11",
    "data-name": "Line 11",
    y1: 134.491,
    transform: "translate(313.625 3956.636)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_12",
    "data-name": "Line 12",
    y1: 134.491,
    transform: "translate(361.661 3956.636)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_13",
    "data-name": "Line 13",
    y1: 134.491,
    transform: "translate(414.377 3956.636)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_14",
    "data-name": "Line 14",
    x2: 283.459,
    transform: "translate(130.541 4040.061)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_15",
    "data-name": "Line 15",
    x2: 283.459,
    transform: "translate(130.541 3998.48)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_16",
    "data-name": "Line 16",
    x2: 283.459,
    transform: "translate(130.541 3956.899)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_17",
    "data-name": "Line 17",
    x2: 283.459,
    transform: "translate(130.541 4081.641)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1862",
    "data-name": "Group 1862",
    transform: "translate(46 3793)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 4.619,
    cy: 4.619,
    r: 4.619,
    transform: "translate(87.565 211.595)",
    fill: "#b94f4f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 4.619,
    cy: 4.619,
    r: 4.619,
    transform: "translate(111.056 215.798)",
    fill: "#b94f4f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 4.619,
    cy: 4.619,
    r: 4.619,
    transform: "translate(136.347 213.435)",
    fill: "#b94f4f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 4.619,
    cy: 4.619,
    r: 4.619,
    transform: "translate(161.638 221.001)",
    fill: "#b94f4f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 4.619,
    cy: 4.619,
    r: 4.619,
    transform: "translate(186.929 204.116)",
    fill: "#b94f4f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20",
    "data-name": "Ellipse 20",
    cx: 4.619,
    cy: 4.619,
    r: 4.619,
    transform: "translate(212.219 187.993)",
    fill: "#b94f4f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_21",
    "data-name": "Ellipse 21",
    cx: 4.619,
    cy: 4.619,
    r: 4.619,
    transform: "translate(237.511 199.001)",
    fill: "#b94f4f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    cx: 4.619,
    cy: 4.619,
    r: 4.619,
    transform: "translate(262.802 216.682)",
    fill: "#b94f4f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    cx: 4.619,
    cy: 4.619,
    r: 4.619,
    transform: "translate(288.092 224.196)",
    fill: "#b94f4f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_24",
    "data-name": "Ellipse 24",
    cx: 4.619,
    cy: 4.619,
    r: 4.619,
    transform: "translate(310.998 237.638)",
    fill: "#b94f4f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    cx: 4.619,
    cy: 4.619,
    r: 4.619,
    transform: "translate(337.405 242.204)",
    fill: "#b94f4f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_26",
    "data-name": "Ellipse 26",
    cx: 4.619,
    cy: 4.619,
    r: 4.619,
    transform: "translate(363.813 240.638)",
    fill: "#b94f4f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M216.214,262.912l22.511,4.019,25.737-3.019,25.587,8.067,25.4-16.752,24.974-16.4,25.475,11.115,25.27,16.986,25.307,8.078,22.709,14.077L465.9,293l25.7-1.917",
    transform: "translate(-77.377 3746.806)",
    fill: "none",
    stroke: "#b94f4f",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpcCostPerPatient);
export default __webpack_public_path__ + "static/media/ppcCostPerPatient.20fd88c0.svg";
export { ForwardRef as ReactComponent };